/* tslint:disable */
/* eslint-disable */
/**
 * ISO Backend Modules API
 * ISO API for the IBE.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var ApiItemType;
(function (ApiItemType) {
    ApiItemType["HOTEL"] = "HOTEL";
    ApiItemType["TOUR"] = "TOUR";
    ApiItemType["CAR"] = "CAR";
    ApiItemType["TRANSPORT"] = "TRANSPORT";
    ApiItemType["FLIGHT"] = "FLIGHT";
    ApiItemType["EXTRA"] = "EXTRA";
    ApiItemType["CHAUFFEUREDSERVICE"] = "CHAUFFEURED_SERVICE";
    ApiItemType["INSURANCE"] = "INSURANCE";
    ApiItemType["TRANSFER"] = "TRANSFER";
    ApiItemType["CRUISE"] = "CRUISE";
    ApiItemType["PACKAGE"] = "PACKAGE";
    ApiItemType["PREDEFINEDPACKAGE"] = "PREDEFINED_PACKAGE";
    ApiItemType["ROOM"] = "ROOM";
    ApiItemType["ROOMRATE"] = "ROOM_RATE";
    ApiItemType["DINING"] = "DINING";
    ApiItemType["LOUNGEACCESS"] = "LOUNGE_ACCESS";
    ApiItemType["AIRPORTTRANSFER"] = "AIRPORT_TRANSFER";
    ApiItemType["MEETANDGREET"] = "MEET_AND_GREET";
    ApiItemType["VOUCHER"] = "VOUCHER";
    ApiItemType["CAMPER"] = "CAMPER";
    ApiItemType["CAMPEREXTRA"] = "CAMPER_EXTRA";
    ApiItemType["SEAT"] = "SEAT";
    ApiItemType["POSTALCODE"] = "POSTAL_CODE";
    ApiItemType["BUS"] = "BUS";
    ApiItemType["INBOUND"] = "INBOUND";
    ApiItemType["OUTBOUND"] = "OUTBOUND";
})(ApiItemType || (ApiItemType = {}));
function ApiItemTypeFromJSON(json) {
    return ApiItemTypeFromJSONTyped(json);
}
function ApiItemTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ApiItemTypeToJSON(value) {
    return value;
}

export { ApiItemType, ApiItemTypeFromJSON, ApiItemTypeFromJSONTyped, ApiItemTypeToJSON };
//# sourceMappingURL=ApiItemType.js.map
